module.exports = __webpack_public_path__ + "assets/img/sdwan-module1-4.4a174ed6.png";